<div class="selectedSubproject" *ngIf="selectedSubproject">
  <button
    class="subprojectPicker"
    data-testid="subproject-picker"
    mat-button
    (click)="onMenuTriggered(isHandset)"
    [matMenuTriggerFor]="subprojectPickerMenu"
    [disabled]="!isAppOnline"
  >
    <div class="d-flex w-100 align-items-center text-truncate" *ngIf="selectedSubproject">
      <mat-icon
        *ngIf="!selectedSubproject.isReleased"
        svgIcon="cancel"
        class="iconLeft"
        matTooltip="Subproject not released"
        i18n-matTooltip="@@shared.subprojectPicker.attrSubprojectNotReleased"
      ></mat-icon>

      <mat-icon
        *ngIf="selectedSubproject.isLocked"
        svgIcon="lock-outline"
        class="iconLeft"
        matTooltip="Subproject locked"
        i18n-matTooltip="@@shared.subprojectPicker.attrSubprojectLocked"
      ></mat-icon>

      <span
        data-testid="selectedSubproject"
        class="text-none text-truncate selectedSubprojectLabel"
        [title]="selectedSubproject.name"
      >
        {{selectedSubproject.name}}
      </span>

      <ng-container
        *ngIf="selectedSubproject.data?.subprojectConfiguration?.fileUpload; else selectedSubprojectLogoPlaceholder"
      >
        <img
          class="subproject-logo d-none d-lg-inline-block ml-auto pl-2"
          appOfflineLogo
          [fileUpload]="selectedSubproject.data?.subprojectConfiguration?.fileUpload"
          [base64EncodedLogoContent]="selectedSubproject.data?.subprojectConfiguration?.base64EncodedLogoContent"
          src=""
          alt=""
        />
      </ng-container>
      <ng-template #selectedSubprojectLogoPlaceholder>
        <span class="ml-auto">&nbsp;</span>
      </ng-template>

      <mat-icon class="iconRight" svgIcon="menu-down"></mat-icon>
    </div>
  </button>
  <button
    *ngIf="!isHandset"
    mat-icon-button
    data-testid="copy-subproject-name"
    [cdkCopyToClipboard]="selectedSubproject.name"
    matTooltip="Copy subproject name to clipboard"
    i18n-matTooltip="@@shared.subprojectPicker.attrCopyToClipboard"
    (click)="copyToClipboardNotification()"
    class="mr-1 button--square button--small"
  >
    <mat-icon class="copyToClipboard" svgIcon="content-copy"></mat-icon>
  </button>
</div>

<mat-menu
  #subprojectPickerMenu="matMenu"
  class="mt-2 navbarMenuPanel subprojectPanel"
  (closed)="onMenuClosed(isHandset)"
>
  <div class="dropdown-header" i18n="@@shared.subprojectPicker.txtSubproject">Subproject</div>
  <button
    [attr.data-testid]="subproject.name"
    mat-menu-item
    class="subprojectPicker_item"
    *ngFor="let subproject of subprojects | sort : 'name' : 'asc' : false; trackBy: trackSubproject"
    [ngStyle]="{'cursor': (subproject.id === selectedSubproject?.id) ? 'default' : 'pointer'}"
    [ngClass]="{'selectedMenuItem' : (subproject.id === selectedSubproject?.id)}"
    (click)="onSubprojectChange(subproject)"
  >
    <div class="d-flex w-100 align-items-center text-truncate">
      <mat-icon
        *ngIf="!subproject.isReleased"
        svgIcon="cancel"
        class="iconLeft"
        matTooltip="Subproject not released"
        i18n-matTooltip="@@shared.subprojectPicker.attrSubprojectNotReleased"
      ></mat-icon>

      <mat-icon
        *ngIf="subproject.isLocked"
        svgIcon="lock-outline"
        class="iconLeft"
        matTooltip="Subproject locked"
        i18n-matTooltip="@@shared.subprojectPicker.attrSubprojectLocked"
      ></mat-icon>

      <span class="text-truncate" [title]="subproject.name">{{subproject.name}}</span>

      <ng-container *ngIf="subproject?.fileUpload; else subprojectLogoPlaceholder">
        <img
          class="subproject-logo ml-auto pl-1"
          [src]="subproject?.fileUpload.externalUrl"
          [alt]=""
          appHideMissingImage
        />
      </ng-container>
      <ng-template #subprojectLogoPlaceholder>
        <span class="ml-auto">&nbsp;</span>
      </ng-template>
    </div>
  </button>
</mat-menu>
